import React, { Component, useEffect, useState } from 'react'

import { connect } from 'react-redux'
import moment from 'moment'
import { commonActions, contracterActions, inboxActions, sentActions, alertActions } from '../../store/actions'

// 컴퍼넌트
import Calendar from '../../module/component-box/Calendar' //캘린더
import Input from '../../module/input'
import Alert from '../../module/alert/Alert'
import SelectBox from '../../module/component-box/SelectBox'
import Pagination from '../../module/pagination-box'
import TextArea from '../../module/textarea'
import Files from '../../module/files'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper.scss'

import 'swiper/components/pagination/pagination.scss'
//import 'swiper/components/navigation/navigation.scss';

const onSelected = (e, type, value) => {
  let changedObj = {
    type: type,
    value: value,
  }
}

class UICase extends Component {
  render() {
    const ExampleWrap = styled.div`
      background: fff;
      border: 2px dashed #dee2e6;
      padding: 20px;
    `

    const BgExampleWrap = styled.div`
      background: #1795b6;
      border: 2px dashed #dee2e6;
      padding: 20px;
    `

    return (
      <React.Fragment>
        <div className="content">
          <div className="inner">
            <h4 className="tit-lev0">UI Components </h4>
            <section>
              <h1>타이틀</h1>
              <ExampleWrap>
                <div className="detail-title">정보</div>
                <span className="sub-title">
                  sub-title = Input Title과 동일<span id="cnt21">3</span>
                </span>
              </ExampleWrap>
            </section>

            <section>
              <h1>버튼 </h1>
              <ExampleWrap>
                <button type="button" className="btn btn-primary">
                  Primary
                </button>
                <button type="button" className="btn btn-danger">
                  Danger
                </button>
                <button type="button" className="btn btn-success">
                  Success
                </button>
                <button type="button" className="btn btn-warning">
                  Warning
                </button>

                <button type="button" className="btn btn-dark-blue">
                  dark-blue
                </button>

                <button type="button" className="btn btn-black">
                  Black
                </button>
                <button type="button" className="btn btn-white">
                  기본
                </button>
                <button type="button" className="btn btn-link">
                  Link
                </button>

                <button type="button" className="btn btn-dark-gray">
                  Dark Gray
                </button>
                <button type="button" className="btn btn-light-gray">
                  light gray
                </button>
                <button className="btn btn-border">휴대폰 본인인증</button>

                <hr />
                <button type="button" className="btn btn-primary btn-lg">
                  Large button
                </button>
                <button type="button" className="btn btn-white btn-lg">
                  Large button
                </button>

                <button type="button" className="btn btn-primary">
                  button
                </button>
                <button type="button" className="btn btn-white">
                  button
                </button>

                <button type="button" className="btn btn-primary btn-md">
                  Medi button
                </button>
                <button type="button" className="btn btn-white btn-md">
                  Medi button
                </button>

                <button type="button" className="btn btn-primary btn-sm">
                  Small button
                </button>
                <button type="button" className="btn btn-white btn-sm">
                  Small button
                </button>

                <button className="btn btn-white btn-add2">파일추가</button>

                <hr />
                <button type="button" className="btn btn-primary " disabled>
                  Disabled button primary
                </button>
                <button type="button" className="btn btn-white" disabled>
                  Disabled button
                </button>
                <hr />

                <button className="regis-btn" disabled>
                  다음
                </button>

                <button className="badge btn-blue">발급완료</button>

                <button className="badge btn-dark-gray">임시저장</button>

                <button className="badge  btn-purple">전송완료</button>

                <button className="badge btn-warning">반려</button>
                <button className="badge btn-success">수취완료</button>

                <button className="badge badge-border">상태미정</button>
                <button className="badge btn-danger">오류통보</button>
              </ExampleWrap>

              <h1>Form </h1>
              <ExampleWrap>
                <Input
                  inputTitle="아이디"
                  type={'text'}
                  id="mobileNo"
                  name="mobileNo"
                  flow={'right'}
                  required={true}
                  className="form-control"
                  title="아이디"
                />

                <Input
                  inputTitle="ReadyOnly"
                  type={'text'}
                  id="adres"
                  name="adres"
                  className="form-control disabled"
                  title="ReadyOnly"
                  readOnly={true}
                  flow={'right'}
                />

                <Input
                  inputTitle="우편번호"
                  type={'text'}
                  id="zipno"
                  name="zipno"
                  className="form-control"
                  title="Input + Btn"
                  flow={'right'}
                  withBtn={true}
                  withBtnName={'주소찾기'}
                />

                <div className="flex-sb flex-c-b">
                  <Input
                    inputTitle="우편번호"
                    type={'text'}
                    id="zipno"
                    name="zipno"
                    className="form-control"
                    wrapperClassName="w-full"
                    title="우편번호"
                    flow={'right'}
                  />
                  <Input
                    inputTitle=""
                    type={'text'}
                    id="zipno"
                    name="zipno"
                    className="form-control  m-l-4"
                    wrapperClassName="w-full"
                    title=""
                    flow={'right'}
                  />
                </div>

                <h3 className="m-t-20">파일첨부 </h3>

                <input type="file" title="fileInput" name={'file'} className="upload-hidden" />

                <div className="input-wrapper">
                  <label className="input-title">사업자등록증</label>
                  <input
                    title="사업자 등록증"
                    type="file"
                    id="registFile"
                    name="registFile"
                    placeholder="사업자등록증을 업로드하세요"
                    className="form-control input input-file"
                    accept=".pdf, .png, .jpg, .gif"
                    required={true}
                  />
                </div>

                <h3 className="m-t-20">증명서 진본검증 파일첨부 </h3>

                <div className="file-add">
                  <label htmlFor="pdfFile">증명서 PDF를 등록하세요</label>
                  <span className="text">파일첨부</span>
                  <input title="첨부파일" type="file" name="pdfFile" id="pdfFile" className="upload-hidden" accept=".pdf" />
                </div>

                <h3 className="m-t-20">파일첨부 컴포넌트 사용중??? </h3>

                <Files
                  id="registFileGroupObj"
                  name="registFileGroupObj"
                  className="form-control input input-file"
                  message={'사업자등록증을 업로드하세요'}
                  required={true}
                  flow={'right'}
                />

                <div className="input-wrapper">
                  <label className="input-title">비고</label>
                  <textarea
                    title="비고"
                    className="form-control input-textarea"
                    name="description"
                    id="description"
                    rows={10}
                    placeholder="비고"
                  />
                </div>

                <div className="flex-l">
                  <input title="이메일 수신동의" type="checkbox" id="almEmailYn" className="checkbox small" />
                  <label htmlFor="almEmailYn">체크박스 기본</label>

                  <input id="isSaveId" type="checkbox" className="checkbox" />
                  <label htmlFor="isSaveId">아이디 저장</label>
                </div>

                <div className="flex-l">
                  <input type="radio" id="signCertTypeA" className="radio" value="A" name="signCertType" checked />
                  <label for="signCertTypeA" className="m-r-30">
                    공인인증서
                    <span
                      tooltip="요청자의 서명 없이 참여자의 정보입력 및 서명이 필요한 청약서를 생성합니다."
                      flow="up"
                      force
                    ></span>
                  </label>

                  <input type="radio" id="signCertTypeB" className="radio" value="B" name="signCertType" />
                  <label for="signCertTypeB">
                    사설인증서
                    <span
                      tooltip="요청자의 서명 없이 참여자의 정보입력 및 서명이 필요한 청약서를 생성합니다."
                      flow="up"
                      force
                    ></span>
                  </label>
                </div>

                <h3>Datepicker </h3>

                <div className="datepicker">
                  <Calendar onSelect={(value) => onSelected(null, 'from', value ? moment(value).format('Y-MM-DD') : '')} />
                  <span className="divider">~</span>
                  <Calendar onSelect={(value) => onSelected(null, 'from', value ? moment(value).format('Y-MM-DD') : '')} />
                </div>

                <div className="notice m-b-10">최종 변경일</div>

                <button className="information-btn btn btn-lg btn-full">저장 </button>
              </ExampleWrap>

              <ExampleWrap>
                <div className="tab">
                  <ul>
                    <li>
                      <a href="#" className="active" data="ALL">
                        전체
                      </a>
                    </li>
                    <li>
                      <a href="#" data="A">
                        발급완료 <span id="cnt1">22</span>
                      </a>
                    </li>
                    <li>
                      <a href="#" data="B">
                        작성완료 <span id="cnt2">57</span>
                      </a>
                    </li>
                    <li>
                      <a href="#" data="C">
                        완료
                        <span id="cnt3">63</span>
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="pagination">
                  <ul>
                    <li>
                      <a href="#">1</a>
                    </li>
                    <li>
                      <a href="#">2</a>
                    </li>
                    <li className="active">
                      <a href="#">3</a>
                    </li>
                    <li>
                      <a href="#">4</a>
                    </li>
                    <li>
                      <a href="#">5</a>
                    </li>
                    <li>
                      <a href="#">6</a>
                    </li>
                    <li>
                      <a href="#">7</a>
                    </li>
                    <li>
                      <a href="#">8</a>
                    </li>
                    <li>
                      <a href="#">9</a>
                    </li>
                    <li>
                      <a href="#">10</a>
                    </li>
                  </ul>
                </div>

                <div className="info info-gray">
                  계약의 참여자인 경우 본인인증을 한 전자계약문서가 조회됩니다.
                  <br />
                  계약문서가 조회되지 않을 경우, 수신하신 문자 또는 메일의 링크를 다시 클릭하여 확인 해 주십시오.
                </div>
              </ExampleWrap>

              <BgExampleWrap>
                <button type="button" className="bt_sch_select">
                  <span>선택</span>
                </button>
                <button type="button" className="bt_sch_sort">
                  <span>정렬</span>
                </button>
                <button type="button" className="bt_sch_search">
                  <span>검색</span>
                </button>
              </BgExampleWrap>
              <h1>Swiper 예제 </h1>

              <div className="swiper-respanl">
                <Swiper
                  className="example"
                  spaceBetween={50}
                  slidesPerView={3}
                  onSlideChange={() => console.log('slide change')}
                  onSwiper={(swiper) => console.log(swiper)}
                  //navigation
                  //pagination={{ clickable: true }}
                  breakpoints={{
                    0: {
                      slidesOffsetBefore: 0,
                      slidesPerView: 1,
                      spaceBetween: 40,
                      centeredSlides: false,
                    },
                    // PC
                    1100: {
                      slidesOffsetBefore: 16,
                      slidesPerView: 3,
                      spaceBetween: 40,
                      centeredSlides: false,
                    },
                  }}
                >
                  <SwiperSlide className="intro1">Slide 1</SwiperSlide>
                  <SwiperSlide className="intro1">Slide 2</SwiperSlide>
                  <SwiperSlide className="intro1">Slide 3</SwiperSlide>
                </Swiper>
              </div>
            </section>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default UICase
